import React, { useEffect, useState, useCallback } from "react";
import i18n from "i18n-react";
import PropTypes from "prop-types";
import { HashLink as Link } from "react-router-hash-link";

import { storageKeys } from "settings";
import { StorageHandler, APIHandler, DataHandler } from "C4";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDropzone } from "react-dropzone";

function BookingForm(props) {
  const [logo, setLogo] = useState(null);
  const [showIframe, setShowIframe] = useState(false);
  const [agentFirstName, setAgentFirstName] = useState("");
  const [agentLastName, setAgentLastName] = useState("");
  const [agentCompany, setAgentCompany] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [agentCity, setAgentCity] = useState("");
  const [agentCountry, setAgentCountry] = useState("");
  const [agentId, setAgentId] = useState("");
  const [userInfo, setUserInfo] = useState({});
  const [fileUrl, setFileUrl] = useState(null);

  function DropZone() {
    const onDrop = useCallback((acceptedFiles) => {
      acceptedFiles.forEach((file) => {
        const reader = new FileReader();

        reader.onabort = () => console.log("file reading was aborted");
        reader.onerror = () => console.log("file reading has failed");
        reader.onload = () => {
          const binaryStr = reader.result;

          // Check file size max 100mb
          if (file.size > 100000000) {
            // Show toast
            toast.error(i18n.translate("Sorry, max File Size is 100mb"), {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            return;
          }

          // Upload file to server and set progress bar
          const data = {
            name: file.name,
            type: file.type,
            size: file.size,
            url: binaryStr,
          };
          StorageHandler.load(storageKeys.accessToken).then((token) => {
            APIHandler.uploadFile(data, token).then((response) => {
              // Set file url to state
              console.log(response);
              setFileUrl(response.path);
              props.handleChangeFile(response.path);
            });
          });
        };

        reader.readAsDataURL(file);
      });
    }, []);

    const { getRootProps, getInputProps } = useDropzone({
      accept: {
        "image/jpeg": [],
        "image/png": [],
        "application/pdf": [],
      },
      onDrop,
    });

    return (
      <section className="container">
        <div {...getRootProps({ className: "dropzone" })}>
          <input {...getInputProps()} />
          <p>Drag and drop files here, or click to select files</p>
          <em>
            (One file, .jpeg, .png and .pdf files will be accepted. Max file
            size is 100mb.)
          </em>
        </div>
      </section>
    );
  }

  const getAppInfo = async () => {
    const appId = await DataHandler.matchAppId();
    const appInfo = await APIHandler.getAppInfo(appId);
    setLogo(appInfo.app[0].logo);
  };

  const getUserInfo = async () => {
    if (!props.agentEmail) {
      return;
    }

    const newUser = await APIHandler.getUserRewards(props.agentEmail);
    if (newUser) {
      setAgentFirstName(newUser.response.first_name);
      setAgentLastName(newUser.response.last_name);
      setAgentCompany(newUser.response.agency_name);
      setPostalCode(newUser.response.zip_code);
      setAgentCity(newUser.response.city);
      setAgentId(newUser.response.id_number);
      setAgentCountry(newUser.response.country);
      setUserInfo(newUser.response);
    }
  };

  const closeIframe = () => {
    setShowIframe(false);

    // Reload user info
    getUserInfo();
  };

  const openFancybox = () => {
    setShowIframe(true);
  };

  useEffect(() => {
    getAppInfo();
    if (Object.keys(userInfo).length === 0) {
      getUserInfo();
    }
  }, [userInfo, props.agentEmail]);

  const {
    airline,
    accommodation,
    arrivalDate,
    bookingNumber,
    departureDate,
    submitForm,
    handleChange,
    reservationNumber,
    typeOfTrip,
    originAirport,
    destinationAirport,
    lastName,
    totalCost,
    numberOfGuests,
    tourOperator,
    wholesaler,
    lengthOfStay,
    agentEmail,
    handleChange1,
    handleChange2,
  } = props;

  const req = " *";
  const params = new URLSearchParams(window.location.search);
  let mobile = false;
  if (params.get("mobile")) {
    mobile = true;
  }

  let email = "";
  if (params.get("email")) {
    email = params.get("email");
  }

  return (
    <div className="contentContainer BookingForm">
      <div className="header">
        <img src={logo} alt="Logo" className="logo" />
        <h3>{i18n.translate("rewards.bookingForm.title")}</h3>
      </div>
      <hr />
      <div className="body">
        <form method="post" id="formRewards">
          <h3>{i18n.translate("rewards.bookingForm.subTitle")}</h3>
          <hr className="subline" />

          <div className="grid userInfo">
            {agentFirstName} {agentLastName}
            <br />
            {agentCompany}
            <br />
            {agentEmail}
            <br />
            {agentCity}
            {postalCode && ", "} {postalCode}
            <br />
            {agentCountry}
            <br />
            {agentId}
            <br />
            <br />
            <a onClick={openFancybox}>Edit your info &gt;</a>
          </div>
          <hr />
          <br />
          <br />
          <h4>{i18n.translate("rewards.bookingForm.sub2")}</h4>
          <p className="required">
            {i18n.translate("rewards.bookingForm.required")}
          </p>
          <div className="grid">
            <div className="item medium">
              <label htmlFor="wholesaler">
                {i18n.translate("rewards.bookingForm.wholesaler").concat(req)}
                <select
                  name="wholesaler"
                  value={wholesaler}
                  onChange={handleChange}
                  required
                >
                  <option value="" disabled>
                    {i18n.translate("rewards.bookingForm.select")}
                  </option>
                  <option value="Adventure World (The Travel Corp)">
                    Adventure World (The Travel Corp)
                  </option>
                  <option value="Air Canada Vacations">
                    Air Canada Vacations
                  </option>
                  <option value="Alaska Airlines Vacations">
                    Alaska Airlines Vacations
                  </option>
                  <option value="Allegiant Airlines">Allegiant Airlines</option>
                  <option value="American Airlines Vacations">
                    American Airlines Vacations
                  </option>
                  <option value="Apple Vacations">Apple Vacations</option>
                  <option value="APT">APT</option>
                  <option value="Bedsonline">Bedsonline</option>
                  <option value="Costco">Costco</option>
                  <option value="Delta Vacations">Delta Vacations</option>
                  <option value="Direct with Hotel">Direct with Hotel</option>
                  <option value="Expedia Australia">Expedia Australia</option>
                  <option value="Expedia TAAP">Expedia TAAP</option>
                  <option value="First Travel Group">First Travel Group</option>
                  <option value="Flight Centre Group">
                    Flight Centre Group
                  </option>
                  <option value="Frontier Airlines">Frontier Airlines</option>
                  <option value="Funjet Vacations">Funjet Vacations</option>
                  <option value="GDS">GDS</option>
                  <option value="Go Global Travel">Go Global Travel</option>
                  <option value="Go Holidays/Helloworld NZ">
                    Go Holidays/Helloworld NZ
                  </option>
                  <option value="GoGo Worldwide Vacations">
                    GoGo Worldwide Vacations
                  </option>
                  <option value="Helloworld Australia / Viva Holidays">
                    Helloworld Australia / Viva Holidays
                  </option>
                  <option value="Hoot Holidays (House of Travel)">
                    Hoot Holidays (House of Travel)
                  </option>
                  <option value="JetBlue Vacations">JetBlue Vacations</option>
                  <option value="Journese">Journese</option>
                  <option value="Luxury Escapes">Luxury Escapes</option>
                  <option value="Mastercard">Mastercard</option>
                  <option value="Pleasant Holidays">Pleasant Holidays</option>
                  <option value="Qantas Holidays">Qantas Holidays</option>
                  <option value="Skylink">Skylink</option>
                  <option value="Southwest Vacations">
                    Southwest Vacations
                  </option>
                  <option value="Spirit Vacations">Spirit Vacations</option>
                  <option value="Sun Country Vacations">
                    Sun Country Vacations
                  </option>
                  <option value="Sunquest">Sunquest</option>
                  <option value="Vacations Hawaii">Vacations Hawaii</option>
                  <option value="Webjet Limited">Webjet Limited</option>
                  <option value="Westjet Vacations">Westjet Vacations</option>
                  <option value="Other">Other</option>
                </select>
              </label>
            </div>

            <div className="item medium">
              <label htmlFor="lastName">
                {i18n.translate("rewards.bookingForm.lastName").concat(req)}
                <input
                  name="lastName"
                  value={lastName}
                  onChange={handleChange}
                  placeholder={i18n.translate("rewards.bookingForm.lastName")}
                  required
                />
              </label>
            </div>

            <div className="item medium">
              <label htmlFor="accommodation">
                {i18n
                  .translate("rewards.bookingForm.accommodation")
                  .concat(req)}
                <input
                  name="accommodation"
                  value={accommodation}
                  onChange={handleChange}
                  placeholder={i18n.translate(
                    "rewards.bookingForm.accommodation"
                  )}
                  required
                  type="string"
                />
              </label>
            </div>

            <div className="item medium">
              <label htmlFor="reservationNumber">
                {i18n
                  .translate("rewards.bookingForm.reservationNumber")
                  .concat(req)}
                <input
                  name="reservationNumber"
                  value={reservationNumber}
                  onChange={handleChange}
                  placeholder={i18n.translate(
                    "rewards.bookingForm.reservationNumber"
                  )}
                  required
                />
              </label>
            </div>

            <div className="item medium">
              <label htmlFor="bookingtNumber">
                {i18n.translate("rewards.bookingForm.flightNumber").concat(req)}
                <input
                  name="bookingNumber"
                  value={bookingNumber}
                  onChange={handleChange}
                  placeholder={i18n.translate(
                    "rewards.bookingForm.flightNumber"
                  )}
                  required
                />
              </label>
            </div>

            {/* <div className="item medium">
            <label htmlFor="numberOfRooms">
              {i18n.translate('rewards.bookingForm.rooms').concat(req)}
              <input
                name="numberOfRooms"
                value={numberOfRooms}
                onChange={handleChange}
                placeholder={i18n.translate('rewards.bookingForm.rooms')}
                required
              />
            </label>
          </div> */}

            <div className="item medium">
              <label htmlFor="typeOfTrip">
                {i18n.translate("rewards.bookingForm.bookingType").concat(req)}
                <select
                  name="typeOfTrip"
                  value={typeOfTrip}
                  onChange={handleChange}
                  required
                >
                  <option value="" disabled>
                    {i18n.translate("rewards.bookingForm.select")}
                  </option>
                  <option value="Group">
                    {i18n.translate("rewards.bookingForm.group")}
                  </option>
                  <option value="Fit">
                    {i18n.translate("rewards.bookingForm.fit")}
                  </option>
                </select>
              </label>
            </div>

            <div className="item medium">
              <label htmlFor="arrivalDate">
                {i18n.translate("rewards.bookingForm.arrivalDate").concat(req)}
                <input
                  type="date"
                  name="arrivalDate"
                  className="DatePicker"
                  onChange={handleChange2}
                  value={arrivalDate}
                  required
                />
              </label>
            </div>

            <div className="item medium">
              <label htmlFor="departureDate">
                {i18n
                  .translate("rewards.bookingForm.departureDate")
                  .concat(req)}
                <input
                  type="date"
                  name="departureDate"
                  className="DatePicker"
                  onChange={handleChange1}
                  value={departureDate}
                  required
                />
              </label>
            </div>

            {/* <div className="item medium">
              <label htmlFor="lengthOfStay">
                {i18n.translate("rewards.bookingForm.lengthOfStay").concat(req)}

                <input
                  name="lengthOfStay"
                  value={lengthOfStay}
                  onChange={handleChange}
                  placeholder={i18n.translate(
                    "rewards.bookingForm.lengthOfStay"
                  )}
                  required
                />
              </label>
            </div> */}

            <div className="item medium">
              <label htmlFor="totalCost">
                {i18n.translate("rewards.bookingForm.cost").concat(req)}
                <div className="totalCost">
                  <div className="dollarSign">$</div>
                  <input
                    name="totalCost"
                    value={totalCost}
                    onChange={handleChange}
                    placeholder={i18n.translate("rewards.bookingForm.cost")}
                    required
                  />
                </div>
              </label>
            </div>

            {/* <div className="item medium">
              <label htmlFor="numberOfGuests">
                {i18n.translate("rewards.bookingForm.guests").concat(req)}
                <input
                  name="numberOfGuests"
                  value={numberOfGuests}
                  onChange={handleChange}
                  placeholder={i18n.translate("rewards.bookingForm.guests")}
                  required
                  type="number"
                />
              </label>
            </div> */}

            {/* <div className="item medium">
              <label htmlFor="airline">
                {i18n.translate("rewards.bookingForm.airline").concat(req)}
                <input
                  name="airline"
                  value={airline}
                  onChange={handleChange}
                  placeholder={i18n.translate("rewards.bookingForm.airline")}
                  required
                />
              </label>
            </div> */}

            {/* <div className="item medium">
              <label htmlFor="originAirport">
                {i18n
                  .translate("rewards.bookingForm.originAirport")
                  .concat(req)}
                <input
                  name="originAirport"
                  value={originAirport}
                  onChange={handleChange}
                  placeholder={i18n.translate(
                    "rewards.bookingForm.originAirport"
                  )}
                  required
                />
              </label>
            </div> */}

            {/* <div className="item medium">
              <label htmlFor="destinationAirport">
                {i18n.translate("rewards.bookingForm.destination").concat(req)}
                <input
                  name="destinationAirport"
                  value={destinationAirport}
                  onChange={handleChange}
                  placeholder={i18n.translate(
                    "rewards.bookingForm.destination"
                  )}
                  required
                />
              </label>
            </div> */}

            {/* <div className="item medium">
            <label htmlFor="birthday">
              {i18n.translate('rewards.bookingForm.birthday').concat(req)}
              <input
                type="date"
                name="birthday"
                className="birthday"
                onChange={handleChange3}
                value={birthday}
                required
              />
            </label>
                </div> */}
            {fileUrl === null && (
              <div className="item large">
                <label htmlFor="file">
                  {i18n.translate("rewards.bookingForm.file")}
                </label>
                <DropZone />
              </div>
            )}
            {fileUrl !== null && (
              <div className="item large success">
                <label htmlFor="file">
                  {i18n.translate("rewards.bookingForm.file")}
                </label>
                <div className="file">
                  <div className="fileIcon">
                    <FontAwesomeIcon icon={["fas", "check-circle"]} />
                    <p>File has been uploaded successfully</p>
                  </div>
                </div>
              </div>
            )}
          </div>
          <br />
          <hr />
          <div className="buttonHolder">
            <button type="submit" className="btn" onClick={submitForm}>
              {i18n.translate("rewards.bookingForm.button")}
            </button>

            {mobile && (
              <Link to={`/main/rewards/terms?mobile=true&email=${email}`}>
                {i18n.translate("rewards.TermsAndConditions.title")}
              </Link>
            )}
            {!mobile && (
              <Link to="/main/rewards/terms">
                {i18n.translate("rewards.TermsAndConditions.title")}
              </Link>
            )}
          </div>
        </form>
      </div>

      {showIframe && (
        <div className="iframe">
          <div
            className="bgIframe"
            onClick={() => {
              closeIframe();
            }}
          />
          <div className="iframeHolder">
            <div
              className="closeIframe"
              href="#"
              onClick={() => {
                closeIframe();
              }}
            >
              <span className="closeText">
                <FontAwesomeIcon icon={["fas", "chevron-left"]} />{" "}
                {i18n.translate("general.back")}
              </span>
            </div>
            <div className="contentIframe">
              <iframe
                width="100%"
                height="100%"
                id="iframeModal"
                src={`https://accounts.travpromobile.com/profile/?header=false&email=${agentEmail}&app_id=633`}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

BookingForm.propTypes = {
  submitForm: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleChange1: PropTypes.func.isRequired,
  handleChange2: PropTypes.func.isRequired,
  handleChange3: PropTypes.func.isRequired,
  handleChangeFile: PropTypes.func.isRequired,
  arrivalDate: PropTypes.string.isRequired,
  originAirport: PropTypes.string.isRequired,
  accommodation: PropTypes.string.isRequired,
  reservationNumber: PropTypes.string.isRequired,
  typeOfTrip: PropTypes.string.isRequired,
  bookingNumber: PropTypes.string.isRequired,
  birthday: PropTypes.string.isRequired,
  departureDate: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  destinationAirport: PropTypes.string.isRequired,
  totalCost: PropTypes.string.isRequired,
  numberOfGuests: PropTypes.number.isRequired,
  tourOperator: PropTypes.string.isRequired,
  wholesaler: PropTypes.string.isRequired,
  lengthOfStay: PropTypes.number.isRequired,
  agentEmail: PropTypes.string.isRequired,
  agentFirstName: PropTypes.string.isRequired,
  agentLastName: PropTypes.string.isRequired,
  agentCompany: PropTypes.string.isRequired,
  postalCode: PropTypes.string.isRequired,
  agentCity: PropTypes.string.isRequired,
  agentCountry: PropTypes.string.isRequired,
  agentId: PropTypes.string.isRequired,
  files: PropTypes.string.isRequired,
};

export default BookingForm;
